import {
  CommonTextInputField,
  type CommonTextInputFieldProps,
} from "../../../../common-ui/form-fields/CommonTextInputField";
import { getFieldProps } from "../../../../common-ui/form-fields/getFieldProps";
import { useMaskInput } from "../../../../common/hooks/useMaskInput";
import type { UpdateIntermodalFormModelStringKeys } from "../../../../services/intermodal/updateIntermodalReducer";
import { useUpdateIntermodalField } from "../../hooks/useUpdateIntermodalField";

interface UpdateIntermodalTextInputFieldProps<
  Key extends UpdateIntermodalFormModelStringKeys,
> extends Omit<CommonTextInputFieldProps, "onValueChange" | "trackerAction"> {
  maskInput?: (value: string) => string;
  name: Key;
}

export function UpdateIntermodalTextInputField<
  Key extends UpdateIntermodalFormModelStringKeys,
>({ name, maskInput, ...props }: UpdateIntermodalTextInputFieldProps<Key>) {
  const { onChange: onFieldChange, ...fieldProps } =
    useUpdateIntermodalField(name);
  const onChange = useMaskInput(onFieldChange, maskInput);

  return (
    <CommonTextInputField
      {...props}
      {...getFieldProps(props, { ...fieldProps, onChange })}
      changed={fieldProps.initialValue !== fieldProps.editedValue}
    />
  );
}
